export const AUS_PHONE_NUMBER_FORMAT = `[\"#### ### ###\"]`;
export const AUS_PREFIX_PHONE_NUMBER_FORMAT = `[\"04\"]`;

export const CONTACT_PHONE_NUMBER_FORMAT = `[\"(##) #### ####\"]`;

export const DATE_FORMAT = `[\"##/##/####\"]`;
